import { tw } from "@careinfo/tailwind";
import { Fragment } from "react";
import dayjs from "dayjs";

export default function LedgerTable({ data }: { data: any[] }) {
  return (
    <tbody>
      {data.map((product) => {
        const openingQty = product.account.opening_quantity ?? 0;
        const billItems = product.bill_items || [];

        const receivedTotal = billItems
          .filter((b) => !b.is_sales)
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

        const deliveredTotal = billItems
          .filter((b) => b.is_sales)
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

        const closingQty = openingQty + receivedTotal - deliveredTotal;

        return (
          <Fragment key={product.account.id}>
            <tr className={tw`bg-white font-semibold`}>
              <td className={tw`py-2 px-5 text-primary`} colSpan={2}>
                {product?.account?.name}
              </td>
              <td></td>
              <td className={tw`py-2 px-5 text-primary`}>
                {product?.account?.unit}
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td className={tw`py-2 px-5`}>{dayjs().format("YY/MM/DD")}</td>
              <td></td>
              <td></td>
              <td className={tw`py-2 px-5 font-semibold`}>Opening Balance</td>
              <td className={tw`py-2 px-5 `}>{openingQty.toFixed(2)}</td>
              <td></td>
            </tr>
            {billItems.map((bill) => {
              const qty = Number(bill.quantity || 0);
              return (
                <tr key={bill.id}>
                  <td className={tw`py-2 px-5`}>
                    {dayjs(bill.bill.voucher_date).format("YY/MM/DD")}
                  </td>
                  <td className={tw`py-2 px-5`}>
                    {dayjs(bill.bill.miti).format("YY/MM/DD")}
                  </td>
                  <td className={tw`py-2 px-5`}>{bill.bill.bill_no}</td>
                  <td className={tw`py-2 px-5`}>{bill.bill.party}</td>
                  <td className={tw`py-2 px-5 `}>
                    {!bill.is_sales ? qty.toFixed(2) : ""}
                  </td>
                  <td className={tw`py-2 px-5 `}>
                    {bill.is_sales ? qty.toFixed(2) : ""}
                  </td>
                </tr>
              );
            })}

            <tr className={tw`bg-gray-100 font-semibold`}>
              <td className={tw`py-2 px-5`}>{dayjs().format("YY/MM/DD")}</td>
              <td></td>
              <td></td>
              <td className={tw`py-2 px-5`}>Total</td>
              <td className={tw`py-2 px-5 `}>{receivedTotal.toFixed(2)}</td>
              <td className={tw`py-2 px-5`}>{deliveredTotal.toFixed(2)}</td>
            </tr>
            <tr className={tw`bg-gray-200 font-semibold`}>
              <td className={tw`py-2 px-5`}>{dayjs().format("YY/MM/DD")}</td>
              <td></td>
              <td></td>
              <td className={tw`py-2 px-5`}>Closing Balance</td>
              <td className={tw`py-2 px-5 `}>{closingQty.toFixed(2)}</td>
              <td></td>
            </tr>
          </Fragment>
        );
      })}
    </tbody>
  );
}
